module.exports = __webpack_public_path__ + "img/5-fourImg.7f01beaf.png";